import $ from "jquery"

class MobileMenu {
  constructor() {
    this.html = $("html")
    this.sidenav = $(".mobilemenu")
    this.hamburgermenu = $(".hamburger")
    this.overlay = $(".overlay")
    this.events()
  }

  events() {
    this.hamburgermenu.on("click", this.openNav.bind(this))
    this.html.on("click", this.clickOutsideOfMenu.bind(this))
    this.sidenav.on("click", this.clickOnMenuArea.bind(this))
    this.sidenav.find("a").on("click", this.clickOnLinkInsideMenu.bind(this))
  }

  openNav(e) {
    e.stopPropagation()
    if (this.sidenav.css("width") == "260px") {
      this.sidenav.css("width", "0").css("box-shadow", "none")
      this.hamburgermenu.toggleClass("open")
      this.overlay.hide()
    } else {
      this.sidenav.css("width", "260px").css("box-shadow", "-2.5px 2.5px 5px 0px gray")
      this.hamburgermenu.toggleClass("open")
      this.overlay.show()
    }
  }

  clickOutsideOfMenu() {
    this.sidenav.css("width", "0")
    if (this.sidenav.css("width") == "260px") {
      this.hamburgermenu.toggleClass("open")
      this.overlay.hide()
    }
  }

  clickOnMenuArea(e) {
    e.stopPropagation()
  }

  clickOnLinkInsideMenu(e) {
    this.sidenav.css("width", "0")
    this.overlay.hide()
    this.hamburgermenu.toggleClass("open")
  }
}

export default MobileMenu
